module.exports = __webpack_public_path__ + "static/img/1-1.b98f553.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/1-1.png
// module id = 3vmv
// module chunks = 0